import React from 'react';
import { Trans } from 'react-i18next';
import { CheckboxGroup as RacCheckboxGroup } from 'react-aria-components';
import { ValidationResult, OptionKeyValue, OptionSelectComponent } from '@myriadgenetics/mgh-types';
import { getDisplayKey, isOptionSelected, convertToTestId } from '../option-select/helpers';
import './index.scss';
import Checkbox from '../../../elements/checkbox';
import { isSimonMedUrl } from '../../../helpers/url';

interface CheckboxGroupProps {
  compDef: OptionSelectComponent;
  className?: string;
  validationResult?: ValidationResult;
  optionsToShow: OptionKeyValue[];
  selectedOptions: OptionKeyValue[];
  onOptionSelected: (selectedOption: OptionKeyValue) => void;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ compDef, className, optionsToShow, selectedOptions, onOptionSelected }) => {
  const componentData = compDef;
  const { labelKey } = componentData?.data;
  const optionsCount = optionsToShow.length;
  const leftOptionsEndCount = optionsCount % 2 === 0 ? optionsCount / 2 : (optionsCount + 1) / 2;
  const leftOptions = optionsToShow.slice(0, leftOptionsEndCount);
  const rightOptions = optionsToShow.slice(leftOptionsEndCount);

  return (
    <RacCheckboxGroup className={`checkbox-wrapper ${className ?? ''}`} value={selectedOptions.map((value: OptionKeyValue) => value.optionKey as string)}>
      {leftOptions.map((option) => (
        <Checkbox
          key={option.optionKey + option.optionValue}
          className={`${isSimonMedUrl() ? 'checkbox__smi-checkbox' : ''} checkbox-left`}
          onChange={() => onOptionSelected(option)}
          dataTestId={convertToTestId(getDisplayKey(option, isOptionSelected(option, selectedOptions)))}
          compDef={compDef}
          value={option.optionKey as string}
          labelKey={labelKey}
        >
          <div className={isSimonMedUrl() ? 'checkbox__smi-checkbox__box' : 'checkbox__box'}></div>
          <Trans i18nKey={getDisplayKey(option, isOptionSelected(option, selectedOptions))} />
        </Checkbox>
      ))}
      {rightOptions.map((option) => (
        <Checkbox
          key={option.optionKey + option.optionValue}
          className={`${isSimonMedUrl() ? 'checkbox__smi-checkbox' : ''} checkbox-right`}
          onChange={() => onOptionSelected(option)}
          dataTestId={convertToTestId(getDisplayKey(option, isOptionSelected(option, selectedOptions)))}
          compDef={compDef}
          value={option.optionKey as string}
          labelKey={labelKey}
        >
          <div className={isSimonMedUrl() ? 'checkbox__smi-checkbox__box' : 'checkbox__box'}></div>
          <Trans i18nKey={getDisplayKey(option, isOptionSelected(option, selectedOptions))} />
        </Checkbox>
      ))}
    </RacCheckboxGroup>
  );
};

export default CheckboxGroup;
